<template>
<m-pageframe
    title="Admin: Link Tree"
>
<v-container>

    <div
        v-for="(item, index) in links"
        :key="index"
    >
        <m-edit-text
            :label="item.text"
            :value="item.value"
            read_only
            hyperlink
        />
    </div>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    computed: {

        links() 
        {
            let ret = [];
            let value = '';

            // Wineshipping
            {
                value = window.location.origin + this.$router.resolve({
                    'name': 'link-tree-wine-shipping',
                    'params' : {
                        'auth': '174c2d21-1f8f-434c-a63d-392802473421',
                    }
                }).href;

                ret.push({
                    'text': 'Wineshipping',
                    'value': value
                });
            }

            // Provide WineDirect credentials
            {
                value = window.location.origin + this.$router.resolve({
                    'name': 'red-chirp-provide-wine-direct-credentials',
                    'params' : {
                    }
                }).href;

                ret.push({
                    'text': 'Public Form: Provide WineDirect credentials',
                    'value': value
                });
            }

            return ret;

        },
    },
}
</script>

<style lang="scss" scoped>
</style>